module.exports = __webpack_public_path__ + "static/media/group-67.6ecabb13.svg";